import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router';


export default class UnauthorizedRoute extends Component {
  static propTypes = {
    component: PropTypes.oneOfType([ PropTypes.node, PropTypes.func, PropTypes.any ]).isRequired,
    userRoles: PropTypes.array,
  };

  render() {
    const { component: Component, userRoles, ...rest } = this.props;
    return (
      <Route {...rest} render={
        props => {
          if (userRoles?.length > 0) {
            return (
              <Redirect to={{
                pathname: '/',
                state: { from: props.location },
              }} />
            );
          }

          return <Component {...props} />;
        }
      } />);
  }
}
